// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yt67h","option":"styles_option__jP44K","active":"styles_active__2Nfe1"};